/** Routes a care manager may use before dispatcher workspace is unlocked. */
export const CARE_MANAGER_ONBOARDING_PATHS = [
  "/care-manager/onboarding",
  "/care-manager/documents",
  "/care-manager/profile",
  "/care-manager/subscription",
  "/care-manager/notifications",
];

export function isCareManagerOnboardingPath(pathname) {
  const path = String(pathname || "");
  return CARE_MANAGER_ONBOARDING_PATHS.some(
    (allowed) => path === allowed || path.startsWith(`${allowed}/`)
  );
}

export function isCareManagerWorkspaceUnlocked(onboarding) {
  if (!onboarding) return false;
  if (typeof onboarding.workspaceUnlocked === "boolean") return onboarding.workspaceUnlocked;
  const stage = String(onboarding.stage || "").toUpperCase();
  if (stage !== "DISPATCHER_ACTIVE") return false;
  return !Boolean(onboarding.dispatcherLocked);
}
